import React from 'react';

export const DummyTable = () => {
	return (
		<div className="dummyTable">
			<div className="game__seq">
				<div className="bids-space current-depth-0 v-not_specified" id="bids-space">
					<div className="test-sequence">
						<p className="seat seat-N">
							N<span className="dealer ">DEALER</span>
						</p>
						<p className="seat seat-E">
							E<span className="dealer dealer-bottom-right ">DEALER</span>
						</p>
						<p className="seat seat-S">
							Gracz S<span className="dealer  show">DEALER</span>
						</p>
						<p className="seat seat-W">
							W<span className="dealer dealer-bottom-left ">DEALER</span>
						</p>
					</div>
				</div>
				<div className="bid">
					<div className="biddingUI">
						<p className="cards__testName">TEST ###</p>
						<h2 className="biddingUI__title">Co powinien zalicytować gracz S?</h2>
						<div className="biddingUI-row row-numbers">
							<button className="biddingUI_button ">1</button>
							<button className="biddingUI_button ">2</button>
							<button className="biddingUI_button ">3</button>
							<button className="biddingUI_button ">4</button>
							<button className="biddingUI_button ">5</button>
							<button className="biddingUI_button ">6</button>
							<button className="biddingUI_button ">7</button>
						</div>
						<div className="biddingUI-row row-numbers">
							<button className="biddingUI_button biddingUI_button-alert ">
								<span className="biddingUI__alertCheck"></span>ALERT
							</button>
						</div>
						<div className="biddingUI-row suits">
							<button className="biddingUI_button">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M11.5 12.5C10.9881 12.5004 10.4823 12.3883 10.0185 12.1716C9.55467 11.9549 9.14416 11.6389 8.81601 11.246C9.2618 12.2572 9.79096 13.2296 10.398 14.153C10.629 14.503 10.378 15 9.96001 15H6.04001C5.62101 15 5.37001 14.503 5.60201 14.153C6.20907 13.2296 6.73823 12.2572 7.18401 11.246C6.80225 11.7022 6.31049 12.0537 5.75517 12.267C5.19986 12.4804 4.59932 12.5487 4.01026 12.4655C3.42121 12.3823 2.86308 12.1504 2.38859 11.7915C1.9141 11.4327 1.5389 10.9588 1.29844 10.4147C1.05797 9.87056 0.960162 9.27412 1.01426 8.68168C1.06835 8.08924 1.27256 7.52037 1.6076 7.02879C1.94264 6.5372 2.39745 6.13913 2.92909 5.87216C3.46072 5.60519 4.05163 5.47814 4.64601 5.503C4.4902 4.98059 4.45858 4.42901 4.55366 3.89221C4.64874 3.35542 4.8679 2.84826 5.19366 2.41115C5.51943 1.97404 5.9428 1.61907 6.43002 1.37453C6.91725 1.13 7.45486 1.00266 8.00001 1.00266C8.54516 1.00266 9.08277 1.13 9.57 1.37453C10.0572 1.61907 10.4806 1.97404 10.8064 2.41115C11.1321 2.84826 11.3513 3.35542 11.4464 3.89221C11.5414 4.42901 11.5098 4.98059 11.354 5.503C11.8193 5.48372 12.2837 5.55749 12.7201 5.71998C13.1566 5.88246 13.5561 6.13041 13.8955 6.44928C14.2349 6.76816 14.5072 7.15155 14.6966 7.577C14.8859 8.00245 14.9884 8.46141 14.9981 8.92698C15.0078 9.39256 14.9246 9.85539 14.7531 10.2884C14.5817 10.7213 14.3256 11.1158 13.9998 11.4485C13.6741 11.7813 13.2852 12.0457 12.8559 12.2262C12.4267 12.4068 11.9657 12.4998 11.5 12.5Z"
										fill="#10530A"
									></path>
								</svg>
							</button>
							<button className="biddingUI_button">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M8.00001 0L2.2536 8L8.00001 16L13.7464 8L8.00001 0Z" fill="#C48208"></path>
								</svg>
							</button>
							<button className="biddingUI_button">
								<svg
									width="17"
									height="16"
									viewBox="0 0 17 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_21_391)">
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M12.75 0.5C10.9793 0.5 9.55294 1.42099 8.48353 2.61749C7.44441 1.37999 6.02066 0.5 4.25 0.5C1.75631 0.5 0 2.51799 0 4.71899C0 5.89949 0.513719 6.74949 1.07631 7.54849L7.68134 15.0015C8.42244 15.656 8.56269 15.656 9.30378 15.0015L15.9237 7.54849C16.5856 6.74949 17 5.89949 17 4.71899C17 2.51799 15.2437 0.5 12.75 0.5Z"
											fill="#A71127"
										></path>
									</g>
									<defs>
										<clipPath id="clip0_21_391">
											<rect width="17" height="16" fill="white"></rect>
										</clipPath>
									</defs>
								</svg>
							</button>
							<button className="biddingUI_button">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_51_19)">
										<path
											d="M15.5 8.2345C15.5 4.61775 8 0.5 8 0.5C8 0.5 0.5 4.61775 0.5 8.2345C0.5 10.3785 2.3065 12.219 4.4845 12.219C5.53275 12.219 6.46575 11.8147 7.16 11.1585L7.0625 11.9847C6.9365 12.882 6.3145 13.7027 5.42175 13.8597L4.25 14.0938V15.5H11.75V14.0938L10.578 13.8593C9.68575 13.7023 9.0635 12.882 8.93725 11.9843L8.84025 11.158C9.534 11.8148 10.467 12.2185 11.5153 12.2185C13.6935 12.2188 15.5 10.3785 15.5 8.2345Z"
											fill="#231F1F"
										></path>
									</g>
									<defs>
										<clipPath id="clip0_51_19">
											<rect width="16" height="16" fill="white"></rect>
										</clipPath>
									</defs>
								</svg>
							</button>
							<button className="biddingUI_button">BA</button>
						</div>
						<div className="biddingUI-row">
							<button className="biddingUI_button biddingUI_button-ktr">X</button>
							<button className="biddingUI_button biddingUI_button-rktr">XX</button>
							<button className="biddingUI_button biddingUI_button-pas">PAS</button>
							<div className="biddingUI-row"></div>
						</div>
					</div>
				</div>
			</div>
			<div className="cards-wrapper">
				<div className="cards">
					<div className="card firstCard">
						<div className="custom-card custom-card--S">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">J</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">J</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--S">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">6</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">6</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--S">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">2</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">2</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--H">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">K</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">K</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--H">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">8</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">8</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--H">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">4</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">4</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--D">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">Q</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">Q</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--D">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">8</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">8</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--D">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">5</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">5</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--D">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">3</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">3</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--C">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">J</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">J</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--C">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">9</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">9</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
					<div className="card">
						<div className="custom-card custom-card--C">
							<div className="custom-card__top">
								<p className="custom-card__number custom-card__top__number">?</p>
								<div className="custom-card__top__suit custom-card__suit">?</div>
							</div>
							<div className="custom-card__middle">
								<p className="custom-card__number custom-card__middle__number">6</p>
							</div>
							<div className="custom-card__bottom">
								<p className="custom-card__number custom-card__bottom__number">6</p>
								<div className="custom-card__bottom__suit custom-card__suit">?</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
